exports.cs = {
  MARKER_CONTENT: {
    OPEN: 'Dnes otevřeno',
    CLOSED: 'Dnes zavřeno'
  }
}
